import AxymaLogo from '../assets/images/Axyma_branco.svg';
import Loading from '../components/Loading/Loading';

function AuthLoading() {
  return (
    <div
      style={{
        backgroundColor: '#3C2864',
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'space-evenly',
      }}
    >
      <img src={AxymaLogo} alt="Logo Axyma" width="40%" />
      <Loading />
    </div>
  );
}

export default AuthLoading;
